<main class="pt-32 lg:pt-35">
  <section class="text-center px-6 max-w-7xl mx-auto mb-[50px]">
    <div class="flex flex-col-reverse lg:flex-row items-center gap-12">
      <div class="lg:w-1/2">
        <p class="text-[#AEAEB2] text-lg mb-4">Our Story</p>
        <h1 class="text-4xl md:text-6xl text-blue-400 font-extrabold mb-6">
          There had to be a <span class="text-[#336799]">better way.</span
          ><br />So we built it.
        </h1>
        <p class="text-lg md:text-xl text-zinc-200 mb-5">
          At Estate360Hub, we envisioned a future where estate management would
          be seamless, secure, and truly smart. We identified the everyday
          friction residents, managers, developers, and organizations faced —
          and engineered a suite of solutions to solve them.
        </p>
        <button
          class="bg-[#336799] text-white px-8 py-3 rounded-full text-lg font-medium hover:opacity-90"
        >
          Explore Our Mission
        </button>
      </div>
      <div class="lg:w-1/2">
        <img
          src="https://placehold.co/700x525/1A1A1A/F2F2F7?text=Our+Vision+Image"
          alt="Our Vision"
          class="rounded-xl shadow-xl object-cover"
        />
      </div>
    </div>
  </section>

  <section class="py-20 px-6 bg-[#1A1A1A]">
    <div class="max-w-6xl mx-auto text-center">
      <h2 class="text-4xl md:text-5xl font-bold mb-16">Our Mission & Values</h2>
      <div class="grid md:grid-cols-2 gap-12 text-left">
        <div
          class="bg-[#1A1A1A] border border-[#3A3A3C] rounded-xl p-6 shadow-lg"
        >
          <h3 class="text-2xl font-bold mb-4">Empowering Communities</h3>
          <p class="text-[#AEAEB2]">
            We believe smart estates are built around people. Our mission is to
            empower residents, managers, and security teams with intuitive tools
            that simplify daily life, improve safety, and create thriving
            communities.
          </p>
        </div>
        <div
          class="bg-[#1A1A1A] border border-[#3A3A3C] rounded-xl p-6 shadow-lg"
        >
          <h3 class="text-2xl font-bold mb-4">Innovation & Security</h3>
          <p class="text-[#AEAEB2]">
            Our platforms are designed with a deep commitment to innovation and
            security. From AI-assisted features to secure QR-based access,
            Estate360Hub delivers tech that protects while enabling.
          </p>
        </div>
        <div
          class="md:col-span-2 bg-[#1A1A1A] border border-[#3A3A3C] rounded-xl p-6 shadow-lg"
        >
          <h3 class="text-2xl font-bold mb-4">Transparency & Trust</h3>
          <p class="text-[#AEAEB2]">
            Trust is our foundation. We provide complete visibility — from
            pricing to platform data — to ensure clarity, accountability, and
            confidence in every interaction across our ecosystem.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="py-24 px-6 bg-[#111111]">
    <div class="max-w-6xl mx-auto text-center">
      <h2 class="text-4xl md:text-5xl font-bold mb-16">Meet Our Visionaries</h2>
      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          class="bg-[#1A1A1A] p-6 rounded-xl text-center border border-[#3A3A3C] shadow-lg"
        >
          <img
            src="https://placehold.co/120x120/336799/FFFFFF?text=CEO"
            class="mx-auto rounded-full border-4 border-[#336799] mb-4"
          />
          <h3 class="text-xl font-bold">Dr. Adebayo Olaniyan</h3>
          <p class="text-[#336799] mb-2">Founder & CEO</p>
          <p class="text-[#AEAEB2] text-sm">
            A visionary leader championing estate innovation and driving digital
            transformation for community living.
          </p>
        </div>
        <div
          class="bg-[#1A1A1A] p-6 rounded-xl text-center border border-[#3A3A3C] shadow-lg"
        >
          <img
            src="https://placehold.co/120x120/E67E22/FFFFFF?text=CTO"
            class="mx-auto rounded-full border-4 border-[#E67E22] mb-4"
          />
          <h3 class="text-xl font-bold">Ms. Chika Okoro</h3>
          <p class="text-[#E67E22] mb-2">Chief Technology Officer</p>
          <p class="text-[#AEAEB2] text-sm">
            Leads technical excellence with a passion for scalable platforms and
            secure, user-centric solutions.
          </p>
        </div>
        <div
          class="bg-[#1A1A1A] p-6 rounded-xl text-center border border-[#3A3A3C] shadow-lg"
        >
          <img
            src="https://placehold.co/120x120/2ECC71/FFFFFF?text=COO"
            class="mx-auto rounded-full border-4 border-[#2ECC71] mb-4"
          />
          <h3 class="text-xl font-bold">Mr. Kwesi Mensah</h3>
          <p class="text-[#2ECC71] mb-2">Chief Operations Officer</p>
          <p class="text-[#AEAEB2] text-sm">
            Focused on seamless implementation and optimized user experience
            across all platforms.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="py-24 bg-[#336799] text-white text-center px-6">
    <div class="max-w-4xl mx-auto">
      <h2 class="text-4xl md:text-5xl font-bold mb-6">
        Join the Future of Estate Management
      </h2>
      <p class="text-lg md:text-xl mb-10">
        Whether you're managing a gated community, running a corporate
        institution, or seeking a smarter way to rent, build, or buy —
        Estate360Hub is your partner in innovation.
      </p>
      <div class="flex flex-col sm:flex-row justify-center gap-4">
        <button
          class="bg-white text-[#336799] px-8 py-4 rounded-full font-medium text-lg hover:opacity-90"
        >
          Request a Demo
        </button>
        <button
          class="border-2 border-white px-8 py-4 rounded-full font-medium text-lg hover:bg-white hover:text-[#336799]"
        >
          Contact Our Team
        </button>
      </div>
    </div>
  </section>
</main>
